import { SidebarMenu } from '@ardoq/sidebar-menu';
import { Icon, IconName } from '@ardoq/icons';
import { TraversalBuilderViewState } from '../types';
import { FlexBox } from '@ardoq/layout';
import { colors } from '@ardoq/design-tokens';
import { Header3 } from '@ardoq/typography';
import { CollapsePathsCommands } from './collapsePathsCommands';
import { CollapsePathsItems } from './CollapsePathsItems';
import { ViewpointBuilderSidebarEmptyState } from '../ViewpointBuilderSidebarEmptyState';
import { PrimaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

type CollapsePathsSidebarProps = {
  state: TraversalBuilderViewState;
  commands: CollapsePathsCommands;
  i18nLocale: I18nLocale;
};

const CollapsePathsSidebar = ({
  state: { pathCollapsingViewState },
  commands,
  i18nLocale,
}: CollapsePathsSidebarProps) => {
  return (
    <SidebarMenu
      isPageBodyMenu
      isResizable
      isRightContent
      headerBody={
        <FlexBox align="center" gap="xsmall" padding="medium">
          <Icon iconName={IconName.COLLAPSE_ALL} color={colors.grey400} />
          <Header3>
            {t(
              i18nLocale,
              'viewpointBuilder:collapsePaths.sidebar.header',
              'Collapse paths'
            )}
          </Header3>
        </FlexBox>
      }
    >
      <FlexBox
        height="full"
        width="full"
        gap="medium"
        backgroundColor="surfaceDefault"
        justify="center"
      >
        {pathCollapsingViewState.rules.length ? (
          <CollapsePathsItems
            pathCollapsingViewState={pathCollapsingViewState}
            commands={commands}
            i18nLocale={i18nLocale}
          />
        ) : (
          <ViewpointBuilderSidebarEmptyState
            title={t(
              i18nLocale,
              'viewpointBuilder:collapsePaths.noRules.title',
              'No paths collapsed yet'
            )}
            description={t(
              i18nLocale,
              'viewpointBuilder:collapsePaths.noRules.description',
              'Select 2 indirectly connected component types and hide all the data between them.'
            )}
          >
            <PrimaryButton onClick={commands.createPathCollapsingRule}>
              <Icon iconName={IconName.ADD_CIRCLE} />{' '}
              {t(
                i18nLocale,
                'viewpointBuilder:collapsePaths.collapseButton',
                'Collapse a path'
              )}
            </PrimaryButton>
          </ViewpointBuilderSidebarEmptyState>
        )}
      </FlexBox>
    </SidebarMenu>
  );
};

export { CollapsePathsSidebar };
